"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = ({ colour = "currentColor" }) => {
    return (react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.4331 26.7376L29.8713 17.5786L29.8782 17.5709C30.4782 16.873 30.4335 15.7955 29.7738 15.1557C29.1052 14.5074 28.0638 14.558 27.4542 15.262L20.1943 23.0691L12.5197 15.2325C11.8941 14.5432 10.8521 14.5193 10.1987 15.1831C9.55377 15.8383 9.53178 16.9167 10.1475 17.6003L19.0383 26.7671C19.3494 27.11 19.7844 27.3055 20.2419 27.2999C20.6995 27.2943 21.1299 27.088 21.4331 26.7376Z", fill: colour }));
};
//# sourceMappingURL=Arrow.js.map